/*
 * @Author: zhang lin
 * @Date: 2022-05-05 17:07:43
 * @LastEditors: zhang lin
 * @LastEditTime: 2023-02-11 13:53:51
 */
import React, { forwardRef, useImperativeHandle } from 'react';
import { FormComponentProps } from 'sup-ui/lib/form';

import { useIntl } from 'react-intl';
import Modal from 'root/components/CommonModal';
import { Form, InputNumber } from 'sup-ui';
import messages from 'root/pages/EnvManage/ServiceManage/messages';
import styles from './index.less';

const formItemLayout = {
  labelCol: {
    span: 11,
  },
  wrapperCol: {
    span: 13,
  },
};

interface FCFormProps extends FormComponentProps {
  visible: boolean;
  onOk: () => {}; // 点击弹框确定回调函数
  onCancel: () => {}; // 点击弹框取消回调函数
  dataInfo: { [propsName: string]: any }; // 表单默认数据
  java?: boolean; // 是否显示java相关的堆内存字段
}

const alarmConfig = forwardRef<FormComponentProps, FCFormProps>((props, ref) => {
  const intl = useIntl();
  const { visible, onOk, onCancel, dataInfo, form, java } = props;
  const { getFieldDecorator } = form;
  // 将关闭弹框的时候 清除输入框的值
  if (!visible) {
    form.resetFields();
  }
  useImperativeHandle(ref, () => ({
    form,
  }));

  return (
    <Modal
      title={intl.formatMessage(messages.alarmThreshold)}
      visible={visible}
      onOk={onOk}
      onCancel={onCancel}
      className={styles.modal}
      height="auto"
      width="556px"
    >
      <Form {...formItemLayout}>
        {java ? <h3 className={styles.title}>{intl.formatMessage(messages.alarmThresholdConfig)}</h3> : null}
        <div className={styles.flex}>
          <Form.Item label="CPU">
            {getFieldDecorator('cpuLimit', {
              initialValue: dataInfo.cpuLimit,
              rules: [
                {
                  required: true,
                  message: intl.formatMessage(messages.cpuNull),
                },
              ],
            })(<InputNumber max={100} min={0} />)}
          </Form.Item>
          <span className={styles.unit}> %</span>
          <Form.Item label={`& ${intl.formatMessage(messages.duration)}`} colon={false}>
            {getFieldDecorator('cpuTime', {
              initialValue: dataInfo.cpuTime,
              rules: [
                {
                  required: true,
                  message: intl.formatMessage(messages.durationNull),
                },
                {
                  message: intl.formatMessage(messages.decimalError),
                  pattern: new RegExp(/^\d{1,}$/),
                },
              ],
            })(<InputNumber min={0} max={1000} maxLength={4} />)}
          </Form.Item>
          <span className={styles.unit}> min</span>
        </div>
        <div className={styles.flex}>
          <Form.Item label={intl.formatMessage(messages.memory)}>
            {getFieldDecorator('memoryLimit', {
              initialValue: dataInfo.memoryLimit,
              rules: [
                {
                  required: true,
                  message: intl.formatMessage(messages.memoryNull),
                },
              ],
            })(<InputNumber max={100} min={0} />)}
          </Form.Item>
          <span className={styles.unit}> %</span>

          <Form.Item label={`& ${intl.formatMessage(messages.duration)}`} colon={false}>
            {getFieldDecorator('memoryTime', {
              initialValue: dataInfo.memoryTime,
              rules: [
                {
                  required: true,
                  message: intl.formatMessage(messages.durationNull),
                },
                {
                  message: intl.formatMessage(messages.decimalError),
                  pattern: new RegExp(/^\d{1,}$/),
                },
              ],
            })(<InputNumber min={0} max={1000} maxLength={4} />)}
          </Form.Item>
          <span className={styles.unit}> min</span>
        </div>
        <div className={styles.flex}>
          <Form.Item label={intl.formatMessage(messages.disk)}>
            {getFieldDecorator('diskLimit', {
              initialValue: dataInfo.diskLimit,
              rules: [
                {
                  required: true,
                  message: intl.formatMessage(messages.diskNull),
                },
              ],
            })(<InputNumber max={100} min={0} />)}
          </Form.Item>
          <span className={styles.unit}> %</span>

          <Form.Item label={`& ${intl.formatMessage(messages.duration)}`} colon={false}>
            {getFieldDecorator('diskTime', {
              initialValue: dataInfo.diskTime,
              rules: [
                {
                  required: true,
                  message: intl.formatMessage(messages.durationNull),
                },
                {
                  message: intl.formatMessage(messages.decimalError),
                  pattern: new RegExp(/^\d{1,}$/),
                },
              ],
            })(<InputNumber min={0} max={1000} maxLength={4} />)}
          </Form.Item>
          <span className={styles.unit}> min</span>
        </div>
        {java ? (
          <>
            <h3 className={styles.title}>java</h3>
            <div className={styles.flex}>
              <Form.Item label={intl.formatMessage(messages.jvmLimit)}>
                {getFieldDecorator('jvmLimit', {
                  initialValue: dataInfo.jvmLimit,
                  rules: [
                    {
                      required: true,
                      message: intl.formatMessage(messages.jvmNull),
                    },
                  ],
                })(<InputNumber max={100} min={0} />)}
              </Form.Item>
              <span className={styles.unit}> %</span>

              <Form.Item label={`& ${intl.formatMessage(messages.duration)}`} colon={false}>
                {getFieldDecorator('jvmTime', {
                  initialValue: dataInfo.jvmTime,
                  rules: [
                    {
                      required: true,
                      message: intl.formatMessage(messages.durationNull),
                    },
                    {
                      message: intl.formatMessage(messages.decimalError),
                      pattern: new RegExp(/^\d{1,}$/),
                    },
                  ],
                })(<InputNumber min={0} max={1000} maxLength={4} />)}
              </Form.Item>
              <span className={styles.unit}> min</span>
            </div>
          </>
        ) : null}
      </Form>
    </Modal>
  );
});

export default Form.create()(alarmConfig);
